module.exports = __webpack_public_path__ + "img/acess.9ea8c0a6.jpg";